import { ArrowDown } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1762028893554-d4c6b6721057?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjaW5lbWF0aWMlMjBmaWxtJTIwc3R1ZGlvJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzc5MjQzMTY4fDA&ixlib=rb-4.1.0&q=85";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex flex-col justify-end overflow-hidden grain"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Cinematic production set"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-[#050505]/20" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/80 via-transparent to-transparent" />
      </div>

      {/* Top meta */}
      <div className="relative z-10 pt-28 md:pt-32 px-6 md:px-12 lg:px-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="h-2 w-2 rounded-full bg-[#E60000] animate-pulse" />
          <span className="eyebrow text-white/80">
            Now booking — 2026 Productions
          </span>
        </div>
        <div className="hidden md:flex items-center gap-6 eyebrow text-white/60">
          <span>NJ / NY</span>
          <span className="h-px w-8 bg-white/30" />
          <span>EST. 2018</span>
        </div>
      </div>

      {/* Headline */}
      <div className="relative z-10 px-6 md:px-12 lg:px-16 pb-16 md:pb-24">
        <div className="max-w-6xl">
          <p className="eyebrow text-[#E60000] mb-6 fade-up">
            Insight Media Productions
          </p>
          <h1
            data-testid="hero-headline"
            className="font-display text-[14vw] md:text-[10vw] lg:text-[9vw] leading-[0.85] uppercase fade-up fade-up-delay-1"
          >
            Impactful
            <br />
            <span className="text-outline-red">Video</span> Production
          </h1>

          <div className="mt-10 md:mt-14 flex flex-col md:flex-row md:items-end md:justify-between gap-8 fade-up fade-up-delay-2">
            <p className="max-w-md text-white/75 text-base md:text-lg leading-relaxed">
              We craft cinematic films for nonprofits, podcasts, courses, and
              brands that need their message to move people — and move
              missions forward.
            </p>

            <div className="flex flex-wrap items-center gap-4">
              <a
                href="#contact"
                data-testid="hero-start-project"
                className="btn-primary"
              >
                Start a Project
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="relative z-10 hidden md:flex items-center gap-3 px-6 md:px-12 lg:px-16 pb-8 text-white/50">
        <ArrowDown size={14} />
        <span className="eyebrow">Scroll to explore</span>
      </div>
    </section>
  );
}
